// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1wCej","alert":"SettungsInbox_alert__3e1w2"};